import { useState, useEffect, useCallback } from 'react';
import api from './api';

export function useCrud(endpoint) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  const fetchData = useCallback(async (params = {}) => {
    setLoading(true);
    try {
      const res = await api.get(endpoint, { params });
      if (res.data.success) {
        setData(res.data.data);
        setTotal(res.data.total || res.data.data.length);
      }
    } catch (err) {
      console.error(`Error fetching ${endpoint}:`, err);
    } finally {
      setLoading(false);
    }
  }, [endpoint]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const create = async (item) => {
    const res = await api.post(endpoint, item);
    if (res.data.success) {
      await fetchData();
      return res.data.data;
    }
    throw new Error(res.data.message);
  };

  const update = async (id, item) => {
    const res = await api.put(`${endpoint}/${id}`, item);
    if (res.data.success) {
      await fetchData();
      return res.data.data;
    }
    throw new Error(res.data.message);
  };

  const remove = async (id) => {
    const res = await api.delete(`${endpoint}/${id}`);
    if (res.data.success) {
      await fetchData();
    }
  };

  return { data, loading, total, fetchData, create, update, remove };
}
